import { render, staticRenderFns } from "./benefits-side-panel.vue?vue&type=template&id=fbed3534&scoped=true"
import script from "./benefits-side-panel.vue?vue&type=script&lang=js"
export * from "./benefits-side-panel.vue?vue&type=script&lang=js"
import style0 from "./benefits-side-panel.vue?vue&type=style&index=0&id=fbed3534&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbed3534",
  null
  
)

export default component.exports